// extracted by mini-css-extract-plugin
export default {"text_error":"style_text_error__a--nt","error":"style_error__gtzfM"};